import script from "./StudentJenphoneRating.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentJenphoneRating.vue?vue&type=script&setup=true&lang=js"

import "./StudentJenphoneRating.vue?vue&type=style&index=0&id=717d57f2&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-717d57f2"]])

export default __exports__